export default "/icons/atlassian_icon.svg";